const statusMap = Object.freeze({
  undefined: <span className="font-weight-bold">Processing</span>,
  Processing: <span className="font-weight-bold">Preparing To Ship</span>,
  "Preparing To Ship": <span className="font-weight-bold">In Transit</span>,
  "In Transit": <span className="font-weight-bold">Delivered</span>,
  Delivered: <></>,
  "Backordered Pending": (
    <span className="font-weight-bold">Customer Action</span>
  ),
  Delayed: <span className="font-weight-bold">Delayed</span>,
  default: "",
});

export const handleNextStatus = (status) => {
  return statusMap[status] || statusMap.default;
};

const nextStatusObj = Object.freeze({
  Processing: "Preparing To Ship",
  "Preparing To Ship": "In Transit",
  "In Transit": "Delivered",
  default: "",
});

export const nextStatusForFilter = (status) => {
  return nextStatusObj[status] || nextStatusObj.default;
};
